<template>
    <v-modal ref="modal">
        <slot slot="title">{{ $t('customer.account.addresses.delivery.add_address') }}</slot>
        <slot slot="buttonContent">
            <v-block type="mini" height="stretch" color="white">
                <span class="u-flex-set"><button class="c-button c-button--icon-only" type="button"><svgicon name="added"></svgicon></button></span>
            </v-block>
        </slot>
        <div class="o-wrapper o-wrapper--center">
            <form action="" class="c-form c-form--horizontal">
                <div class="u-max-700 c-form-row">
                    <v-form-row>
                        <v-input v-model="Address.Name" name="address_name" :fluid="true" :error="Validate.Name">
                            <slot slot="label">{{ $t('customer.account.addresses.form.name.label') }}</slot>
                        </v-input>
                    </v-form-row>

                    <v-form-row>
                        <v-custom-select v-model="selectedCountry"
                                         :options="DeliveryCountryOptions"
                                         option-name="content"
                                         option-value="value"
                                         track-by="value"
                                         search-label="content"
                                         name="delivery-address"
                                         :error="Validate.CountryId">
                            <slot slot="label">{{ $t('customer.account.addresses.form.country.label') }}</slot>
                        </v-custom-select>
                    </v-form-row>

                    <v-form-row>
                        <v-input v-model="Address.ZipCode" name="address_zipcode" :fluid="true" :error="Validate.ZipCode">
                            <slot slot="label">{{ $t('customer.account.addresses.form.postal_code.label') }}</slot>
                        </v-input>
                    </v-form-row>

                    <v-form-row>
                        <v-input v-model="Address.HouseNumber" name="address_house_number" :fluid="true" :error="Validate.Number" @blur="completeAddress">
                            <slot slot="label">{{ $t('customer.account.addresses.form.house_number.label') }}</slot>
                        </v-input>
                    </v-form-row>

                    <v-form-row>
                        <v-input v-model="Address.Street" name="address_street" :fluid="true" :error="Validate.Street">
                            <slot slot="label">{{ $t('customer.account.addresses.form.street.label') }}</slot>
                        </v-input>
                    </v-form-row>

                    <v-form-row>
                        <v-input v-model="Address.City" name="address_city" :fluid="true" :error="Validate.City">
                            <slot slot="label">{{ $t('customer.account.addresses.form.city.label') }}</slot>
                        </v-input>
                    </v-form-row>

                    <v-form-row>
                        <v-input v-model="Address.Email" name="address_mail" :fluid="true" :error="Validate.Email">
                            <slot slot="label">{{ $t('customer.account.addresses.form.mail.label') }}</slot>
                        </v-input>
                    </v-form-row>

                    <v-form-row>
                        <v-input v-model="Address.Phone" name="address_phone" :fluid="true" :error="Validate.Phone">
                            <slot slot="label">{{ $t('customer.account.addresses.form.phone.label') }}</slot>
                        </v-input>
                    </v-form-row>

                    <v-form-row>
                        <div class="c-form-item c-form-item--horizontal">
                            <v-label></v-label>
                            <button @click.prevent="addNewAddress" class="c-button c-button--alpha">{{ $t('customer.account.addresses.create.form.submit') }}</button>
                        </div>
                    </v-form-row>
                </div>
            </form>
        </div>       
    </v-modal>
</template>

<script>
    import VModal from '@/components/modal/Modal'
    import VBlock from '@/components/blocks/Block'
    import VFormRow from '@/components/form/Row'
    import VInput from '@/components/form/Input'
    import VLabel from '@/components/form/Label'
    import VCustomSelect from '@/components/form/CustomSelect'

    export default {
        components: {
            VModal,
            VBlock,
            VFormRow,
            VInput,
            VCustomSelect,
            VLabel
        },
        data() {
            return {
                Address: {
                    Name: "",
                    Street: "",
                    HouseNumber: "",
                    ZipCode: "",
                    City: "",
                    CountryName: "",
                    CountryId: "",
                    Email: "",
                    Phone: "",
                    Type: "DELIVERY"
                },
                Validate: {}
            }
        },
        props: {
            customerKey: Number
        },
        created() {
            this.$store.dispatch('getAvailableCountryOptions');
        },
        computed: {
            DeliveryCountryOptions() {
                return this.$store.getters.AvailableCountryOptions;
            },
            selectedCountry: {
                get () {
                    let output;
                    output = this.DeliveryCountryOptions.find((obj) => {
                        return obj.value === this.Address.CountryName;
                    });

                    if (output) {
                        this.$set(this.Address, 'CountryName', output.value);
                        this.$set(this.Address, 'CountryId', output.code);
                    }

                    return output ? output : {};
                },
                set (value) {
                    this.$set(this.Address, 'CountryName', value.value);
                    this.$set(this.Address, 'CountryId', value.code);
                    return value;
                }
            }
        },
        methods: {
            addNewAddress() {
                this.$store.dispatch('sendAddress', {
                    customer: this.customerKey,
                    body: this.Address
                }).then((response) => {
                    if (response.status > 300 && response.data.ModelState) {
                        this.setValidation(response.data.ModelState);
                    } else {
                        this.$emit('addressAdded', this.Address);
                        this.$refs.modal.closeDialog();    
                    }
                });            
            },

            // SET VALIDATION
            setValidation(errors) {
                Object.keys(errors).forEach(function (key) {
                    key = key.replace('model.', '');
                    errors[key] = errors['model.' + key][0];
                    delete errors['model.' + key];
                });

                this.Validate = errors;
            },

            completeAddress() {
                if((this.selectedCountry && this.selectedCountry.code == "NL") 
                && (this.Address.ZipCode && this.Address.ZipCode.length > 0)
                && (this.Address.HouseNumber && this.Address.HouseNumber.length > 0))
                {
                    //Do call to maybe autocomplete street
                    this.$store.dispatch('getStreet', { postalCode: this.Address.ZipCode, houseNr: this.Address.HouseNumber }).then((response) => {
                        this.Address.Street = response.street;
                    });
                }
            }
        }
    }
</script>

<style lang="scss" scoped>

    @import "~@/assets/scss/private";

</style>



// WEBPACK FOOTER //
// src/components/form/addressSelect/AddAddress.vue